import react from '../../assets/icons/react.svg'


const languages = [
    {
        icon: react,
        name: 'Python',
        level: '95'
    },
    {
        icon: react,
        name: 'C & C++',
        level: '60'
    },
    {
        icon: react,
        name: 'HTML',
        level: '80'
    },
    {
        icon: react,
        name: 'CSS',
        level: '60'
    },
    {
        icon: react,
        name: 'Flask',
        level: '80'
    },
    {
        icon: react,
        name: 'Bootstrap',
        level: '60'
    },
    {
        icon: react,
        name: 'JavaScript',
        level: '65'
    },
    {
        icon: react,
        name: 'ReactJS',
        level: '60'
    },
    {
        icon: react,
        name: 'SQL',
        level: '70'
    },
    {
        icon: react,
        name: 'PHP',
        level: '65'
    }
]

const tools = [
    {
        icon: react,
        name: 'Airflow',
        level: '85'
    },
    {
        icon: react,
        name: 'GCP',
        level: '45'
    },
    {
        icon: react,
        name: 'GitHub',
        level: '90'
    },
    {
        icon: react,
        name: 'Nexla',
        level: '90'
    },
    {
        icon: react,
        name: 'Lucidchart',
        level: '80'
    }

]

const Interpersonal = [
    {
        icon: react,
        name: 'Communication',
        level: '80'
    },
    {
        icon: react,
        name: 'Problem Solving',
        level: '90'
    },
    {
        icon: react,
        name: 'Strategic Planning',
        level: '92'
    },
    {
        icon: react,
        name: 'Leadership',
        level: '80'
    }

]

const Other = [
    {
        icon: react,
        name: 'Presentation',
        level: '85'
    },
    {
        icon: react,
        name: 'Time Management',
        level: '95'
    },
    {
        icon: react,
        name: 'Self Confidence',
        level: '90'
    },
    {
        icon: react,
        name: 'Integrity',
        level: '80'
    }

]

export { tools, languages, Interpersonal, Other }